<template>
    <div class="page">
        <div class="page-body">
            <div>
                <h2 class="page-title">Смотрите лучшие фильмы онлайн</h2>
                <span class="page-desc">Только новые фильмы, в хорошем качастве!</span>
                <v-btn class="reg-btn" large color="error" @click="onOpenReg">Регистрация</v-btn>
            </div>
        </div>

        <Reg ref="reg" @success="onSuccessReg"/>

        <v-dialog v-model="regSuccess" width="600">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>Регистрация завершена</v-card-title>
                <v-card-text>Вы успешно зарегистрировались в онлайн кинотеатре</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="regSuccess = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import Reg from './reg-subscribe.vue'
    import mixin from '@/web/mixin.js'

    export default {
        mixins: [mixin],
        components: {
            Reg
        },
        data () {
            return {
                regSuccess: false
            }
        },
        methods: {
            onOpenReg () {
                this.$refs.reg.open()
            },
            onSuccessReg () {
                this.regSuccess = true
                this.event('registered', {
                    site: 'online-cinema-subscribe'
                })
            }
        },
        mounted () {
            this.event('view', {site: 'online-cinema-subscribe'})
        }
    }
</script>
<style lang="stylus" scoped>
    .page {
        background url('/images/web-assets/cinema-bg.jpg') fixed
        background-size cover
        height 100%
        position relative
        &::after {
            content ""
            position absolute
            top 0
            bottom 0
            left 0
            right 0
            background-color #000
            opacity 0.7
            z-index 2
        }
    }
    .page-title {
        color #fff
        margin-bottom 10px
        font-size 30px
        text-transform uppercase
    }
    .page-body {
        top 0
        z-index 10
        bottom 0
        left 0
        position absolute
        margin auto
        right 0
        width 600px
        height 250px
        display flex
        align-items center
        text-align center
        justify-content center
    }
    .reg-btn {
        font-size 25px
    }
    .page-desc {
        color #fff
        margin-bottom 20px
        display block
        text-align center
    }
</style>